export default __webpack_public_path__ + "static/media/mephoto.39511402.JPEG";